import enviro from 'enviro';
const APP_NAME = 'ecosystem-marketplace-apps';
const GATE_PREFIX = 'gate::';
export const debug = (key = '') => enviro.debug(`${APP_NAME}${key ? `_${key}` : ''}`) === 'true';
export const setDebug = (key, ...args) => enviro.setDebug(`${APP_NAME}_${key}`, ...args);
export const debugGate = gate => debug(`${GATE_PREFIX}${gate}`);
export const setDebugGate = (gate, ...args) => setDebug(`${GATE_PREFIX}${gate}`, ...args);
export const isQa = () => enviro.isQa(APP_NAME);
export const deployed = () => enviro.deployed(APP_NAME);
const logDebuggingGroup = (group, keys, debugFn = debug) => {
  console.group(`${group}:`);
  keys.forEach(key => console.log(`${key}:`, debugFn(key), '\n'));
  console.groupEnd();
};
export const logDebugging = () => {
  try {
    if (!(window && window.localStorage)) {
      return;
    }
    const keys = [];
    const gates = [];
    Object.keys(window.localStorage).forEach(_key => {
      let key = _key.toLowerCase();
      if (!(key.startsWith(APP_NAME) && key.endsWith('_debug'))) {
        return;
      }
      key = key.replace(`${APP_NAME}_`, '').replace(/_?debug$/, '');
      if (key) {
        if (key.startsWith(GATE_PREFIX)) {
          gates.push(key.replace(GATE_PREFIX, ''));
        } else {
          keys.push(key);
        }
      }
    });
    console.groupCollapsed(`[${APP_NAME}] debugging`);
    logDebuggingGroup('keys', keys);
    logDebuggingGroup('gates', gates, debugGate);
    console.groupEnd();
  } catch (__error) {
    return;
  }
};